// extracted by mini-css-extract-plugin
export default {"BookActivity_buttons":"BookActivity_BookActivity_buttons__xnKqd"};